import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetCoupon = () => {
    
  return (
    API_GET(API.GetCoupon)
  )
}

